export default __webpack_public_path__ + "static/media/hero2.a41ba7ef.jpg";